// Events are NOT compatible
// IF they are not "internal bet builder" selections AND
// EITHER at least one of them doesn't have "express_id" (indicates event is not compatible with any other event at all)
// OR they have same "express_id" (indicates events are not compatible together)
//
// Internal bet builder selections from the same game DO combine, because the bet
// builder server validates their compatibility via get_bet_builder_odds. The
// filter below returns TRUE for selections that should be kept and FALSE for ones
// to drop when a new selection is added.

import { ISelection } from "src/constants/interfaces/bet";

export const getEventsCompatibilityFilter = (newSelection: ISelection) => (
  (eachSelection: ISelection) => {
    const sameGame = eachSelection.game.id === newSelection.game.id;

    // Both the existing and incoming selection are internal bet builder events
    // for the same game — allow them to coexist.
    const bothBetBuilder =
      !!eachSelection.event.isInternalBetBuilder &&
      !!newSelection.event.isInternalBetBuilder;

    if (sameGame && bothBetBuilder) return true;

    const noExpressId = !newSelection.market.express_id || !eachSelection.market.express_id;
    const sameExpressId = newSelection.market.express_id === eachSelection.market.express_id;
    const notCompatible = sameExpressId || noExpressId;

    const shouldRemove = sameGame && notCompatible;

    return !shouldRemove;
  }
);
